function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import getPathToString from './../getPathToString.js';
import isObject from './isObject.js';
var rxVarName = /^[a-zA-Z_$]+([\w_$]*)$/;
var rxQuot = /"/g;
var has = Object.prototype.hasOwnProperty;
export default function getIterate(_) {
  var pathToString = getPathToString(_);
  function iterate(item) {
    var _item = item,
      options = _item.options,
      obj = _item.obj,
      callback = _item.callback;
    options.pathFormatArray = options.pathFormat == 'array';
    item.depth = 0;
    var broken = false;
    var breakIt = function breakIt() {
      broken = true;
      return false;
    };
    while (item) {
      if (broken) break;
      if (!item.inited) {
        item.inited = true;
        item.info = describeValue(item.value, options.ownPropertiesOnly);
        if (options.checkCircular) {
          item.circularParentIndex = -1;
          item.circularParent = null;
          item.isCircular = false;
          if (item.info.isObject && !item.info.isEmpty) {
            var parent = item.parent;
            while (parent) {
              if (parent.value === item.value) {
                item.isCircular = true;
                item.circularParent = parent;
                item.circularParentIndex = item.depth - parent.depth - 1;
                break;
              }
              parent = parent.parent;
            }
          }
        }
        item.children = [];
        if (options.childrenPath) {
          options.childrenPath.forEach(function (cp, i) {
            var children = _.get(item.value, cp);
            var info = describeValue(children, options.ownPropertiesOnly);
            if (!info.isEmpty) {
              item.children.push([cp, options.strChildrenPath[i], children, info]);
            }
          });
        }
        item.isLeaf = item.isCircular || options.childrenPath !== undefined && !item.children.length || !item.info.isObject || item.info.isEmpty;
        item.needCallback = (item.depth || options.includeRoot) && (!options.leavesOnly || item.isLeaf);
        if (item.needCallback) {
          var contextReader = new ContextReader(obj, options, breakIt);
          contextReader.setItem(item, false);
          try {
            item.res = callback(item.value, item.key, item.parent && item.parent.value, contextReader);
          } catch (err) {
            if (err.message) {
              err.message += '\ncallback failed before deep iterate at:\n' + pathToString(item.path);
            }
            throw err;
          }
        }
        if (broken) {
          break;
        }
        if (item.res !== false) {
          if (!broken && !item.isCircular && item.info.isObject) {
            if (options.childrenPath !== undefined && (item.depth || !options.rootIsChildren)) {
              item.childrenItems = [];
              if (item.children.length) {
                item.children.forEach(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 4),
                    cp = _ref2[0],
                    scp = _ref2[1],
                    children = _ref2[2],
                    info = _ref2[3];
                  item.childrenItems = [].concat(_toConsumableArray(item.childrenItems), _toConsumableArray(info.isArray ? getElements(item, children, options, cp, scp) : getOwnChildren(item, children, options, cp, scp)));
                });
              }
            } else {
              item.childrenItems = item.info.isArray ? getElements(item, item.value, options, [], '') : getOwnChildren(item, item.value, options, [], '');
            }
          }
        }
        item.currentChildIndex = -1;
      }
      if (item.childrenItems && item.currentChildIndex < item.childrenItems.length - 1) {
        item.currentChildIndex++;
        item.childrenItems[item.currentChildIndex].parentItem = item;
        item = item.childrenItems[item.currentChildIndex];
        continue;
      }
      if (item.needCallback && options.callbackAfterIterate) {
        var _contextReader = new ContextReader(obj, options, breakIt);
        _contextReader.setItem(item, true);
        try {
          callback(item.value, item.key, item.parent && item.parent.value, _contextReader);
        } catch (err) {
          if (err.message) {
            err.message += '\ncallback failed after deep iterate at:\n' + pathToString(item.path);
          }
          throw err;
        }
      }
      item = item.parentItem;
    }
  }
  return iterate;
  function getElements(item, children, options, childrenPath, strChildrenPath) {
    var strChildPathPrefix;
    if (!options.pathFormatArray) {
      strChildPathPrefix = item.strPath || '';
      if (strChildrenPath && strChildPathPrefix && !strChildrenPath.startsWith('[')) {
        strChildPathPrefix += '.';
      }
      strChildPathPrefix += strChildrenPath || '';
    }
    var res = [];
    for (var i = 0; i < children.length; i++) {
      var val = children[i];
      if (val === undefined && !(i in children)) {
        continue;
      }
      var strChildPath = void 0;
      var pathFormatString = !options.pathFormatArray;
      if (pathFormatString) {
        strChildPath = "".concat(strChildPathPrefix, "[").concat(i, "]");
      }
      res.push({
        value: val,
        key: i + '',
        path: [].concat(_toConsumableArray(item.path || []), _toConsumableArray(childrenPath), [i + '']),
        strPath: strChildPath,
        depth: item.depth + 1,
        parent: {
          value: item.value,
          key: item.key,
          path: pathFormatString ? item.strPath : item.path,
          parent: item.parent,
          depth: item.depth,
          info: item.info
        },
        childrenPath: childrenPath.length && childrenPath || undefined,
        strChildrenPath: strChildrenPath || undefined
      });
    }
    return res;
  }
  function getOwnChildren(item, children, options, childrenPath, strChildrenPath) {
    var strChildPathPrefix;
    if (!options.pathFormatArray) {
      strChildPathPrefix = item.strPath || '';
      if (strChildrenPath && strChildPathPrefix && !strChildrenPath.startsWith('[')) {
        strChildPathPrefix += '.';
      }
      strChildPathPrefix += strChildrenPath || '';
    }
    var res = [];
    var pathFormatString = !options.pathFormatArray;
    for (var childKey in children) {
      if (options.ownPropertiesOnly && !has.call(children, childKey)) {
        continue;
      }
      var strChildPath = void 0;
      if (pathFormatString) {
        if (rxVarName.test(childKey)) {
          if (strChildPathPrefix) {
            strChildPath = "".concat(strChildPathPrefix, ".").concat(childKey);
          } else {
            strChildPath = "".concat(childKey);
          }
        } else {
          strChildPath = "".concat(strChildPathPrefix, "[\"").concat(childKey.replace(rxQuot, '\\"'), "\"]");
        }
      }
      res.push({
        value: children[childKey],
        key: childKey,
        path: [].concat(_toConsumableArray(item.path || []), _toConsumableArray(childrenPath), [childKey]),
        strPath: strChildPath,
        depth: item.depth + 1,
        parent: {
          value: item.value,
          key: item.key,
          path: pathFormatString ? item.strPath : item.path,
          parent: item.parent,
          depth: item.depth,
          info: item.info
        },
        childrenPath: childrenPath.length && childrenPath || undefined,
        strChildrenPath: strChildrenPath || undefined
      });
    }
    return res;
  }
}
var ContextReader = /*#__PURE__*/function () {
  function ContextReader(obj, options, breakIt) {
    _classCallCheck(this, ContextReader);
    this.obj = obj;
    this._options = options;
    this['break'] = breakIt;
  }
  _createClass(ContextReader, [{
    key: "setItem",
    value: function setItem(item, afterIterate) {
      this._item = item;
      this.afterIterate = afterIterate;
    }
  }, {
    key: "path",
    get: function get() {
      return this._options.pathFormatArray ? this._item.path : this._item.strPath;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._item.parent;
    }
  }, {
    key: "parents",
    get: function get() {
      if (!this._item._parents) {
        this._item._parents = [];
        var curParent = this._item.parent;
        while (curParent) {
          this._item._parents[curParent.depth] = curParent;
          curParent = curParent.parent;
        }
      }
      return this._item._parents;
    }
  }, {
    key: "depth",
    get: function get() {
      return this._item.depth;
    }
  }, {
    key: "isLeaf",
    get: function get() {
      return this._item.isLeaf;
    }
  }, {
    key: "isCircular",
    get: function get() {
      return this._item.isCircular;
    }
  }, {
    key: "circularParentIndex",
    get: function get() {
      return this._item.circularParentIndex;
    }
  }, {
    key: "circularParent",
    get: function get() {
      return this._item.circularParent;
    }
  }, {
    key: "childrenPath",
    get: function get() {
      return this._options.childrenPath !== undefined && (this._options.pathFormatArray ? this._item.childrenPath : this._item.strChildrenPath) || undefined;
    }
  }, {
    key: "info",
    get: function get() {
      return this._item.info;
    }
  }]);
  return ContextReader;
}();
function isObjectEmpty(value, ownPropertiesOnly) {
  for (var key in value) {
    if (!ownPropertiesOnly || has.call(value, key)) {
      return false;
    }
  }
  return true;
}
function describeValue(value, ownPropertiesOnly) {
  var res = {
    isObject: isObject(value)
  };
  res.isArray = res.isObject && Array.isArray(value);
  res.isEmpty = res.isArray ? !value.length : res.isObject ? isObjectEmpty(value, ownPropertiesOnly) : true;
  return res;
}